import React from 'react';
import { ToastContainer as BootstrapToastContainer } from 'react-bootstrap';
import ToastNotification from './ToastNotification';
import { useNotifications } from '../../context/NotificationContext';

const ToastContainer = () => {
  const { toasts, removeToast } = useNotifications();
  
  // If no toasts, return null
  if (toasts.length === 0) {
    return null;
  }
  
  return (
    <div 
      style={{
        position: 'fixed',
        top: '20px',
        right: '100px',
        zIndex: 9999,
        maxWidth: '320px'
      }}
      className="toast-container-custom"
    >
      <BootstrapToastContainer>
        {toasts.map(toast => (
          <ToastNotification
            key={toast.id}
            notification={toast}
            onClose={removeToast}
          />
        ))}
      </BootstrapToastContainer>
    </div>
  );
};

export default ToastContainer; 